import PropTypes from "prop-types";

function ScaleAdjuster({ settings }) {
    const { isBoxAnalysis, imageHeight, inputMinValue, inputMaxValue, yAxisMaxValue, handleInputChange } = settings;

    return (
        <div
            style={{
                position: "absolute",
                left: "5.3%",
                top: "74px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
                height: `${imageHeight}px`,
            }}
        >
            <span
                style={{
                    opacity: 1,
                    zIndex: 1,
                    display: "flex",
                    width: "50px",
                    flexDirection: "column",
                }}
            >
                <label
                    htmlFor="max-value"
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                    }}
                >
                    Max
                </label>
                <input
                    className="input_border_color"
                    id="max-value"
                    type="number"
                    value={inputMaxValue}
                    onChange={(e) => handleInputChange(e, "max")}
                    step={isBoxAnalysis ? 1 : 0.1}
                    min={Number(inputMinValue) + 1}
                    max={yAxisMaxValue}
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                    }}
                />
            </span>
            <span
                style={{
                    opacity: 1,
                    zIndex: 1,
                    display: "flex",
                    width: "50px",
                    flexDirection: "column",
                }}
            >
                <input
                    className="input_border_color"
                    id="min-value"
                    type="number"
                    value={inputMinValue}
                    onChange={(e) => handleInputChange(e, "min")}
                    step={isBoxAnalysis ? 1 : 0.1}
                    min={0}
                    max={Number(inputMaxValue) - 1}
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                    }}
                />
                <label
                    htmlFor="min-value"
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                    }}
                >
                    Min
                </label>
            </span>
        </div>
    );
}

ScaleAdjuster.propTypes = {
    settings: PropTypes.object,
};

export default ScaleAdjuster;
